/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum TicketType {
	Task = 'task',
	Constraint = 'constraint',
	Milestone = 'milestone',
}

export enum MilestoneType {
	START = 'startMilestone',
	FINISH = 'finishMilestone',
}
